// extracted by mini-css-extract-plugin
export var divider = "_mb-0";
export var systemMessage = "_mb-1";